import { Buffer3384y49aj0pxr as Buffer } from './Buffer.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var RealBufferedSinkClass;
function RealBufferedSink() {
  if (RealBufferedSinkClass === VOID) {
    class $ {
      constructor(sink) {
        this.u3z_1 = sink;
        this.v3z_1 = false;
        this.w3z_1 = new (Buffer())();
      }
      l3v(source, byteCount) {
        // Inline function 'okio.internal.commonWrite' call
        // Inline function 'kotlin.check' call
        if (!!this.v3z_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.w3z_1.l3v(source, byteCount);
        this.x3z();
        return Unit_instance;
      }
      b3z(byteString) {
        // Inline function 'okio.internal.commonWrite' call
        // Inline function 'kotlin.check' call
        if (!!this.v3z_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.w3z_1.b3z(byteString);
        return this.x3z();
      }
      d3z(string) {
        // Inline function 'okio.internal.commonWriteUtf8' call
        // Inline function 'kotlin.check' call
        if (!!this.v3z_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.w3z_1.d3z(string);
        return this.x3z();
      }
      e3z(string, beginIndex, endIndex) {
        // Inline function 'okio.internal.commonWriteUtf8' call
        // Inline function 'kotlin.check' call
        if (!!this.v3z_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.w3z_1.e3z(string, beginIndex, endIndex);
        return this.x3z();
      }
      f3z(b) {
        // Inline function 'okio.internal.commonWriteByte' call
        // Inline function 'kotlin.check' call
        if (!!this.v3z_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.w3z_1.f3z(b);
        return this.x3z();
      }
      x3z() {
        // Inline function 'okio.internal.commonEmitCompleteSegments' call
        // Inline function 'kotlin.check' call
        if (!!this.v3z_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        var byteCount = this.w3z_1.m3y();
        if (byteCount > 0n) {
          this.u3z_1.l3v(this.w3z_1, byteCount);
        }
        return this;
      }
      lc() {
        // Inline function 'okio.internal.commonFlush' call
        // Inline function 'kotlin.check' call
        if (!!this.v3z_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        if (this.w3z_1.n3v_1 > 0n) {
          this.u3z_1.l3v(this.w3z_1, this.w3z_1.n3v_1);
        }
        this.u3z_1.lc();
        return Unit_instance;
      }
      l6() {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonClose' call
          if (this.v3z_1) {
            tmp$ret$0 = Unit_instance;
            break $l$block;
          }
          var thrown = null;
          try {
            if (this.w3z_1.n3v_1 > 0n) {
              this.u3z_1.l3v(this.w3z_1, this.w3z_1.n3v_1);
            }
          } catch ($p) {
            if ($p instanceof Error) {
              var e = $p;
              thrown = e;
            } else {
              throw $p;
            }
          }
          try {
            this.u3z_1.l6();
          } catch ($p) {
            if ($p instanceof Error) {
              var e_0 = $p;
              if (thrown == null)
                thrown = e_0;
            } else {
              throw $p;
            }
          }
          this.v3z_1 = true;
          if (!(thrown == null))
            throw thrown;
          tmp$ret$0 = Unit_instance;
        }
        return tmp$ret$0;
      }
      toString() {
        // Inline function 'okio.internal.commonToString' call
        return 'buffer(' + toString(this.u3z_1) + ')';
      }
    }
    initMetadataForClass($, 'RealBufferedSink');
    RealBufferedSinkClass = $;
  }
  return RealBufferedSinkClass;
}
//region block: exports
export {
  RealBufferedSink as RealBufferedSinkipqv3pv5gqfq,
};
//endregion

//# sourceMappingURL=RealBufferedSink.mjs.map
